import { useHistory, useLocation, useParams } from 'react-router-dom';
import { History, Location } from 'history';
import qs from 'query-string';

export interface UseRouteProps {
  location: Location<any>;
  history: History<any>;
  params: any;
  query: any;
}
export function useRouter(): UseRouteProps {
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const query = qs.parse(location.search);
  return {
    location,
    history,
    params,
    query,
  };
}
